<script setup lang="ts">
import { ref, onMounted } from "vue";
import rvapi, {
  type PromotionCodeLogEntry,
  type SystemLogEntry,
} from "@/rvapi";
import PagedLogList from "@/components/PagedLogList.vue";
import { utc2local } from "@/utils";

const activeTab = ref("events");
const systemLog = ref<SystemLogEntry[]>([]);
const promotionCodeLog = ref<PromotionCodeLogEntry[]>([]);
const systemLogLoading = ref(true);
const promotionCodeLogLoading = ref(true);

const getDetails = (data: Record<string, string>) => {
  let str = "";
  for (const property of Object.keys(data)) {
    str += `${property}: ${data[property]}\n`;
  }
  return str;
};
const downloadSystemLog = async () => {
  systemLog.value = await rvapi.searchGenericLookup("systemlog/", "*", 100, 0);
  systemLogLoading.value = false;
};

const downloadPromotionCodeLog = async () => {
  promotionCodeLog.value = await rvapi.searchGenericLookup(
    "promotioncodelog/",
    "*",
    100,
    0,
  );
  promotionCodeLogLoading.value = false;
};

onMounted(async () => {
  systemLogLoading.value = true;
  promotionCodeLogLoading.value = true;
  const promise = downloadSystemLog();
  await downloadPromotionCodeLog();
  await promise;
});
const changed = (e: any) => {
  activeTab.value = e.detail;
};
</script>

<template>
  <pn-tablist stackedicons="false" value="events" @tabchange="changed">
    <pn-tab value="events" label="Events & Notes"></pn-tab>
    <pn-tab value="system" label="System log"></pn-tab>
    <pn-tab value="codes" label="Promotion code log"></pn-tab>
  </pn-tablist>
  <p>&nbsp;</p>
  <section v-show="activeTab == 'events'">
    <PagedLogList type="admin" searchId="1" />
  </section>

  <section v-show="activeTab == 'system'">
    <pn-table bordered="true">
      <table>
        <thead>
          <tr>
            <th>Date</th>
            <th>Message</th>
            <th>User</th>
            <th>Details</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="log in systemLog" :key="log._id">
            <td>{{ utc2local(log.logDate) }}</td>
            <td>{{ log.message }}</td>
            <td>{{ log.user }}</td>
            <td>
              <pre>{{ getDetails(log.data) }}</pre>
            </td>
          </tr>
        </tbody>
      </table>
    </pn-table>
    <pn-spinner v-show="systemLogLoading" />
  </section>

  <section v-show="activeTab == 'codes'">
    <pn-table bordered="true">
      <table>
        <thead>
          <tr>
            <th>Date</th>
            <th>Code</th>
            <th>User</th>
            <th>Details</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="log in promotionCodeLog" :key="log._id">
            <td>{{ utc2local(log.createdAt) }}</td>
            <td>{{ log.code }}</td>
            <td>{{ log.createdBy }}</td>
            <td>
              <pre>{{ getDetails(log.data) }}</pre>
            </td>
          </tr>
        </tbody>
      </table>
    </pn-table>
    <pn-spinner v-show="promotionCodeLogLoading" />
  </section>
</template>
<style lang="scss" scoped>
.separator {
  height: 3rem;
}
</style>
